/* eslint-disable max-len */

import React, { PureComponent } from 'react';

import { toJpeg } from 'html-to-image';

import { enum as ranks } from '../../../../../../enums/affiliate-ranks';

import { formatMoney } from '../../../shared/format';
import pluralize from '../../../../../shared/js/pluralize';

const videos = {
	en: {},
	ru: {
		50: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/videos/50.MOV'),
		63: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/videos/63.MOV'),
		75: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/videos/75.MOV'),
		78: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/videos/78.MOV')
	}
};
const img = {
	template: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/template.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/template.jpg')
	},
	country: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/country.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/country.jpg')
	},
	preview: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/preview.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/preview.jpg')
	},
	manager: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/manager.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/manager.jpg')
	},
	general: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/general.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/general.jpg')
	},
	results: {
		en: {
			0: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/results/0.jpg'),
			1: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/results/1.jpg'),
			2: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/results/2.jpg'),
			3: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/results/3.jpg'),
			4: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/results/4.jpg'),
			5: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/results/5.jpg')
		},
		ru: {
			0: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/results/0.jpg'),
			1: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/results/1.jpg'),
			2: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/results/2.jpg'),
			3: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/results/3.jpg'),
			4: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/results/4.jpg'),
			5: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/results/5.jpg')
		}
	},
	ranks: {
		en: {
			0: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/0.jpg'),
			1: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/1.jpg'),
			2: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/2.jpg'),
			3: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/3.jpg'),
			4: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/4.jpg'),
			5: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/ranks/5.jpg')
		},
		ru: {
			0: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/0.jpg'),
			1: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/1.jpg'),
			2: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/2.jpg'),
			3: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/3.jpg'),
			4: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/4.jpg'),
			5: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/ranks/5.jpg')
		}
	},
	offer: {
		en: require('../../../../apps/rocket/assets/img/dashboard/year-results/en/offer.jpg'),
		ru: require('../../../../apps/rocket/assets/img/dashboard/year-results/ru/offer.jpg')
	},
	money: require('../../../../apps/rocket/assets/img/dashboard/year-results/money.png'),
	share: require('../../../../apps/rocket/assets/img/dashboard/year-results/share.png')
};

function Background({ image, visible, children }) {
	return (
		<div
			className='year-results-popup-background'
			style={{
				backgroundImage: `url('${image}')`,
				opacity: visible ? 1 : 0,
				zIndex: visible ? 1 : 0
			}}
		>
			{children}
		</div>
	);
}

export function Preview({ lang, visible }) {
	return (
		<Background visible={visible} image={img.preview[lang]} />
	);
}

export function Leads({ intl, lang, visible, leads }) {
	return (
		<Background visible={visible} image={img.template[lang]}>
			<div className='year-results-popup-template-value'>
				<div className='year-results-popup-template-value-count'>
					{formatMoney(leads ? leads.count : 0)}
				</div>
				<div className='year-results-popup-template-value-label'>
					{intl('лидов ты сделал за год')}
				</div>
			</div>
			<div className='year-results-popup-template-label'>
				{leads && leads.percent > 0 && intl('Это на %s%% больше, чем в 2022 году', leads.percent)}
			</div>
		</Background>
	);
}

export function Income({ intl, lang, visible, income }) {
	return (
		<Background visible={visible} image={img.template[lang]}>
			<div className='year-results-popup-template-value'>
				<div className='year-results-popup-template-value-count'>
					{formatMoney(income)} $
				</div>
				<div className='year-results-popup-template-value-label'>
					{intl('денег ты заработал')}
				</div>
			</div>
			<div className='year-results-popup-template-label'>
				{intl('Уже придумал, на что потратишь?')}
			</div>
		</Background>
	);
}

export function Quids({ intl, lang, visible, quids }) {
	const money = quids / 100;

	return (
		<Background visible={visible} image={img.template[lang]}>
			<div className='year-results-popup-template-value'>
				<div className='year-results-popup-template-value-count'>
					{formatMoney(quids)}
				</div>
				<div className='year-results-popup-template-value-label'>
					{intl('quid заработал')}
				</div>
			</div>
			<div className='year-results-popup-quids-momey'>
				<div
					className='year-results-popup-quids-image'
					style={{
						backgroundImage: `url('${img.money}')`
					}}
				/>
				{intl('А это между прочим')}
				<span>{formatMoney(money)}</span>{intl(pluralize(money, ['доллар', 'доллара', 'долларов']))}!
			</div>
			<div className='year-results-popup-template-label'>
				{intl('Ты крут! Продолжай в том же духе!')}
			</div>
		</Background>
	);
}

export function Rank({ lang, visible, rank_id }) {
	return (
		<Background visible={visible} image={img.ranks[lang][rank_id]} />
	);
}

export function Country({ intl, lang, visible, country }) {
	return (
		<Background visible={visible} image={img.country[lang]}>
			<div className='year-results-popup-country-value'>
				<div className='year-results-popup-country-flag'>
					{country && (
						<span className={`flag-icon flag-icon-${country.code.toLowerCase()}`} />
					)}
				</div>
				{country && country.name}
			</div>
			<div className='year-results-popup-country-label'>
				{intl('Хотел бы отправиться туда в новое путешествие?')}
			</div>
		</Background>
	);
}

export function Offer({ intl, lang, visible, offer }) {
	return (
		<Background visible={visible} image={img.offer[lang]}>
			<div className='year-results-popup-offer-image' style={{ backgroundImage: offer && `url('${offer.image}')` }} />
			<div className='year-results-popup-offer-value'>
				{offer && offer.title}
			</div>
			<div className='year-results-popup-offer-label'>
				{intl('Надеюсь, ты в таком оффере не нуждаешься!')}
			</div>
		</Background>
	);
}

export class Manager extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isPlayed: false
		};
	}

	render() {
		const { lang, visible, manager } = this.props;

		const video = manager && videos[lang][manager.id];

		return (
			<Background visible={visible} image={img.manager[lang]}>
				{video ? (
					<div className='year-results-popup-manager-video'>
						<video
							ref={(e) => { this.ref = e; }}
							src={video}
							onEnded={() => this.setState({ isPlayed: false })}
						/>
						{!this.state.isPlayed && (
							<svg
								className='year-results-popup-manager-video-icon'
								viewBox='0 0 384 512'
							>
								<path d='M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z' />
							</svg>
						)}
						<div
							className='year-results-popup-manager-video-play'
							onClick={() => {
								if (video) {
									this.setState((state) => ({ isPlayed: !state.isPlayed }));
									this.ref[!this.state.isPlayed ? 'play' : 'pause']();
								}
							}}
						/>
					</div>
				) : manager && (
					<div
						className='year-results-popup-manager-image'
						style={{
							backgroundImage: `url('${manager.avatar}')`
						}}
					/>
				)}
				<div className='year-results-popup-manager-value'>
					{manager && manager.name}
				</div>
			</Background>
		);
	}
}

export class General extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false
		};
	}

	render() {
		const { intl, lang, visible, leads, income, quids, rank_id, country, offer, manager } = this.props;

		return (
			<Background visible={visible} image={img.general[lang]}>
				<div className='year-results-popup-general-leads'>
					{formatMoney(leads ? leads.count : 0)}
				</div>
				<div className='year-results-popup-general-income'>
					{formatMoney(income)}$
				</div>
				<div className='year-results-popup-general-quids'>
					{formatMoney(quids)}
				</div>
				<div className='year-results-popup-general-rank'>
					{ranks.find((r) => r.id === rank_id).name}
				</div>
				<div className='year-results-popup-general-country'>
					{country && country.name}
				</div>
				<div className='year-results-popup-general-offer'>
					{offer && offer.title}
				</div>
				<div className='year-results-popup-general-manager'>
					{manager && manager.name}
				</div>
				<button
					className='year-results-popup-general-button'
					disabled={this.state.isLoading}
					onClick={async () => {
						const node = document.getElementById('year-end-results');

						if (!node) return;

						this.setState({ isLoading: true });

						const href = await toJpeg(node);

						const link = document.createElement('a');
						link.download = 'year-end-results.jpg';
						link.href = href;
						link.click();

						this.setState({ isLoading: false });
					}}
				>
					<div
						className='year-results-popup-general-share'
						style={{
							backgroundImage: `url('${img.share}')`
						}}
					/>
					{!this.state.isLoading ? intl('Поделиться с друзьями') : intl('Загрузка') + '...'}
				</button>
			</Background>
		);
	}
}

export function Share({ lang, visible, leads, income, quids, rank_id, country, offer, manager }) {
	return (
		<div
			className='year-results-popup-share-background'
			style={{
				backgroundImage: `url('${img.results[lang][rank_id]}')`,
				opacity: visible ? 1 : 0
			}}
			id='year-end-results'
		>
			<div className='year-results-popup-share-leads'>
				{formatMoney(leads ? leads.count : 0)}
			</div>
			<div className='year-results-popup-share-income'>
				{formatMoney(income)}$
			</div>
			<div className='year-results-popup-share-quids'>
				{formatMoney(quids)}
			</div>
			<div className='year-results-popup-share-rank'>
				{ranks.find((r) => r.id === rank_id).name}
			</div>
			<div className='year-results-popup-share-country'>
				{country && country.name}
			</div>
			<div className='year-results-popup-share-offer'>
				<div
					className='year-results-popup-share-offer-image'
					style={{
						backgroundImage: offer && `url('${offer.image}')`
					}}
				/>
				{offer && offer.title}
			</div>
			<div className='year-results-popup-share-manager'>
				{manager && manager.name}
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/year-results-popup/banners.js